import { useEffect, useState } from 'react'
import { Grid, IconButton, Typography, Tooltip, Breadcrumbs, Badge, Pagination } from '@mui/material'
import ListIcon from '@mui/icons-material/List';
import GridViewIcon from '@mui/icons-material/GridView';
import TuneIcon from '@mui/icons-material/Tune';
import FaceIcon from '@mui/icons-material/Face';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import { SearcherKFCProductModal } from './components/SearcherKFCProductModal'
import HeaderV3 from './components/HeaderV3';
import { useSearcherStore } from '../../hooks/useSearcherStore';
import { FiltersV3 } from './components/FiltersV3';
import { CustomBreadcrumb } from '../../components/common/CustomBreadcrumb/CustomBreadcrumb';
import { ProductListV3 } from './components/ProductListV3';
import { ShoppingCartV3 } from './components/ShoppingCartV3';
import { RecommendedV3 } from './components/RecommendedV3';
import { CustomerV3 } from './components/CustomerV3';
import { useShoppingCartStore } from '../../hooks/useShoppingCartStore';
import { useAuthStore } from '../../hooks/useAuthStore';
import { useTicketStore } from '../../hooks/useTicketStore';

const SearcherV3 = () => {
    const { user } = useAuthStore()
    const { getSearchProducts, getFilterProducts } = useSearcherStore()
    const {
        selectedCategory,
        setPricelistName,
        selectedSubCategory,
        selectedSpecificAttribute,
        selectedUseAttribute,
        selectedCustomer,
    } = useSearcherStore()
    const { productsCount, getShoppingCart, createShoppingCart, changeGlobalDiscount } = useShoppingCartStore()
    const { getTicket } = useTicketStore()

    const [loadingproducts, setLoadingproducts] = useState<boolean>(false);
    const [loadingsearch, setLoadingsearch] = useState<boolean>(false);
    const [products, setProducts] = useState<any>([]);
    const [datasearch, setdatasearch] = useState<any>([]);

    const [recommendedBar, setRecommendedBar] = useState<string>('')
    const [presentation, setPresentation] = useState<string>('list')
    const [showModalProduct, setShowModalProduct] = useState<boolean>(false)
    const [showRecommended, setShowRecommended] = useState<boolean>(false)
    const [showFilters, setShowFilters] = useState<boolean>(false)
    const [relevanceSelected, setRelevanceSelected] = useState<any>(null)
    const [product, setProduct] = useState<any>(null)
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [count, setCount] = useState<number>(6)

    useEffect(() => {
        getShoppingCartData()
        getTicketApi()
    }, [])

    useEffect(() => {
        getFilterProductsApi()
    }, [currentPage])

    const getShoppingCartData = async () => {
        await getShoppingCart({ iduser_created: user.id, status_ticket: 0 })
    }

    const getTicketApi = async () => {
        await getTicket({ status_invoice: '0', iduser_created: user.id })
    }

    const getSearchProductsApi = async (data: any) => {
        try {
            setLoadingsearch(true);
            const response = await getSearchProducts(data);
            if (!response) {
                setdatasearch([]);
                setLoadingsearch(false);
                return false;
            } else {
                setdatasearch(response || []);
                setLoadingsearch(false);
            }
            setLoadingsearch(false);
        } catch (error) {
            setLoadingsearch(false);
        }
    }

    const getFilterProductsApi = async (data?: any) => {
        try {
            setLoadingproducts(true);

            let payload: any = {
                page: currentPage,
                perPage: 16
            }

            if (selectedCategory) payload = { ...payload, idcategory_product: selectedCategory.id }
            if (selectedSubCategory) payload = { ...payload, idsubcategory_product: selectedSubCategory.id }
            if (selectedSpecificAttribute) payload = { ...payload, idspecific_attribute: selectedSpecificAttribute.id }
            if (selectedUseAttribute) payload = { ...payload, idspecific_use: selectedUseAttribute.id }
            payload = { ...payload, ...data }

            const response = await getFilterProducts(payload);
            if (!response) {
                setProducts([]);
                setLoadingproducts(false);
                return false;
            } else {
                const name_pricelist = response[0]?.name_pricelist ?? null;
                setPricelistName(name_pricelist || null);
                setProducts(response || []);
                setLoadingproducts(false);
            }
            setLoadingproducts(false);
        } catch (error) {
            setLoadingproducts(false);
        }
    }

    const handleChangeContent = (type: string) => {
        if (recommendedBar === type) {
            setShowRecommended(false)
            setRecommendedBar('')
        } else {
            setShowRecommended(true)
            setRecommendedBar(type)
        }
    }

    const handleChangeGrid = (type: string) => {
        setPresentation(type)
    }

    const handleCloseContent = () => {
        setShowRecommended(false)
        setRecommendedBar('')
    }

    const handlePageChange = (event, page) => {
        setCurrentPage(page)
        if (page === count - 1) {
            setCount(count + 1)
        }
    }

    const handleSelectProduct = async (idproduct: number, quantity?: number) => {
        let payload: any = {
            iduser_created: user.id,
            idproduct: idproduct,
            quantity: quantity ?? 1
        }
        if (selectedCustomer) payload = { ...payload, idcustomer: selectedCustomer.id }
        const response = await createShoppingCart(payload)
        if (response === true) getShoppingCart({ iduser_created: user.id })
    }

    const showMoreProduct = (product: any) => {
        setProduct(product)
        setShowModalProduct(true)
    }

    const handleChangeGlobalDiscount = async (idshop_cart: number, globaldiscount: number) => {
        await changeGlobalDiscount(idshop_cart, { global_discount: globaldiscount })
        getShoppingCart({ iduser_created: user.id })
    }

    return (
        <>
            {/* Barra de navegación */}
            <HeaderV3
                //al escribir
                getSearchProducts={getSearchProductsApi}
                setdatasearch={setdatasearch}
                datasearch={datasearch}
                //al seleccionar un filtro
                getFilterProducts={getFilterProductsApi}
                setProducts={setProducts}
                handleSelectProduct={handleSelectProduct}
                showMoreProduct={showMoreProduct}
            />

            <Grid container xs={12} spacing={2}>
                {/* Cabecera */}
                <Grid item xs={12} md={12} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                    <Grid sx={{ width: '75%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                        <Grid item xs={12} md={2} >
                            <IconButton sx={{ borderRadius: '5px', backgroundColor: showFilters ? '#91CBF9' : '', color: showFilters ? 'white' : '' }} onClick={() => setShowFilters(!showFilters)}>
                                <TuneIcon fontSize="small" />
                                <Typography style={{ marginLeft: '5px' }}>Más filtros</Typography>
                            </IconButton>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 3 }}>
                                {selectedCategory && <CustomBreadcrumb label={selectedCategory.name} />}
                                {selectedSubCategory && <CustomBreadcrumb label={selectedSubCategory.name} />}
                            </Breadcrumbs>
                        </Grid>
                        <Grid item xs={12} md={3} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                            <Tooltip title={'Vista de listado'}>
                                <IconButton sx={{ borderRadius: '5px', marginRight: '2px', backgroundColor: presentation === 'list' ? '#91CBF9' : '', color: presentation === 'list' ? 'white' : '' }} onClick={() => handleChangeGrid('list')}>
                                    <ListIcon fontSize="small" />
                                    <Typography style={{ marginLeft: '5px' }}>Lista</Typography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={'Vista de grid'}>
                                <IconButton sx={{ borderRadius: '5px', marginRight: '2px', backgroundColor: presentation === 'grid' ? '#91CBF9' : '', color: presentation === 'grid' ? 'white' : '' }} onClick={() => handleChangeGrid('grid')}>
                                    <GridViewIcon fontSize="small" />
                                    <Typography style={{ marginLeft: '5px' }}>Grid</Typography>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid sx={{ width: '25%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', padding: '10px' }}>
                        {/* <Tooltip title={'Recomendados'}>
                            <IconButton onClick={() => handleChangeContent('home')} sx={{ borderRadius: '15px', backgroundColor: recommendedBar === 'home' ? '#91CBF9' : '', color: recommendedBar === 'home' ? 'white' : '#91CBF9' }}>
                                <HouseIcon fontSize='medium' />
                            </IconButton>
                        </Tooltip> */}
                        <Tooltip title={'Carrito de compras'}>
                            <IconButton onClick={() => handleChangeContent('shoppingCar')} sx={{ borderRadius: '15px', backgroundColor: recommendedBar === 'shoppingCar' ? '#91CBF9' : '', color: recommendedBar === 'shoppingCar' ? 'white' : '#91CBF9' }}>
                                <Badge badgeContent={productsCount || 0} color="error">
                                    <ShoppingCartIcon fontSize='medium' />
                                </Badge>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={'Cliente'}>
                            <IconButton onClick={() => handleChangeContent('customer')} sx={{ borderRadius: '15px', backgroundColor: recommendedBar === 'customer' ? '#91CBF9' : '', color: recommendedBar === 'customer' ? 'white' : '#91CBF9' }}>
                                <FaceIcon fontSize='medium' />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>

                {/* Ventana de filtros */}
                {showFilters && <FiltersV3 setShowFilters={setShowFilters} getFilterProducts={getFilterProductsApi} />}

                {/* Visualización de productos */}
                <Grid item xs={12} md={showRecommended && showFilters ? 6 : showRecommended || showFilters ? 9 : 12}>
                    <ProductListV3
                        products={products}
                        presentation={presentation}
                        handleSelectProduct={handleSelectProduct}
                        showMoreProduct={showMoreProduct}
                    />
                </Grid>

                {/* Ventana de recomendados */}
                {showRecommended && (
                    <Grid item xs={12} md={3} style={{ height: '70vh', backgroundColor: 'whitesmoke', borderRadius: '15px', overflowY: 'scroll', margin: '0px auto' }}>
                        <div style={{ width: '100%', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                            {/* Ventana de recomendados */}
                            {recommendedBar === 'home' &&
                                <RecommendedV3
                                    relevanceSelected={relevanceSelected}
                                    setShowModalProduct={setShowModalProduct}
                                    handleCloseContent={handleCloseContent} />
                            }

                            {/* Ventana de carrito de compras */}
                            {recommendedBar === 'shoppingCar' &&
                                <ShoppingCartV3
                                    handleChangeContent={handleChangeContent}
                                    handleCloseContent={handleCloseContent}
                                    getShoppingCartData={getShoppingCartData}
                                    handleChangeGlobalDiscount={handleChangeGlobalDiscount} />
                            }
                            {/* Ventana de cliente */}
                            {recommendedBar === 'customer' && <CustomerV3 handleCloseContent={handleCloseContent} />}
                        </div>
                    </Grid>
                )}


            </Grid>

            {/*Paginacion */}
            <Grid container spacing={2} pt={!showRecommended && !showFilters ? 2 : 0} mt={(showRecommended || showFilters) ? 1 : 0}>
                {showFilters && <Grid item xs={0} md={3} />}
                <Grid item xs={12}
                    md={showRecommended && showFilters ? 12 : (showRecommended || showFilters ? 9 : 12)}
                    sx={{ display: 'flex', justifyContent: 'center' }}
                >
                    <Pagination
                        count={count}
                        shape="rounded"
                        page={currentPage}
                        onChange={handlePageChange}
                    />
                </Grid>
            </Grid>

            {
                showModalProduct &&
                <SearcherKFCProductModal
                    open={showModalProduct}
                    closeModal={() => setShowModalProduct(false)}
                    product={product}
                    handleSelectProduct={handleSelectProduct}
                />
            }
        </>
    )
}

export default SearcherV3